import { render } from "./controls.vue?vue&type=template&id=169e5294&scoped=true"
import script from "./controls.vue?vue&type=script&lang=js"
export * from "./controls.vue?vue&type=script&lang=js"

import "./controls.vue?vue&type=style&index=0&id=169e5294&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-169e5294"]])

export default __exports__